import Image from 'next/image'
import Link from 'next/link'
import { Prism as SyntaxHighlighter } from 'react-syntax-highlighter';
import { oneDark } from 'react-syntax-highlighter/dist/cjs/styles/prism';

export function useMDXComponents(components) {
    return {
        ...components,
        Image: (props) => <Image alt={props.alt || ''} {...props} />,
        Link: (props) => <Link {...props} />,
        code({
            inline,
            className,
            children,
            ...props
        }) {
            const match = /language-(\w+)/.exec(
                className || '',
            );
            return !inline ? (
                <SyntaxHighlighter
                    language={(match && match[1]) || ''}
                    style={oneDark}
                    customStyle={{ margin: 0 }}
                >
                    {String(children).replace(/\n$/, '')}
                </SyntaxHighlighter>
            ) : (
                <code className={className} {...props}>
                    {children}
                </code>
            );
        },
    }
}

